import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
const AdornedButton = ({ children, loading, ...rest }) => {
    if (loading) {
        rest = { ...rest, onClick: undefined };
    }
    return (React.createElement(Button, { ...rest },
        children,
        loading && (React.createElement(CircularProgress, { size: "0.8125rem", style: { marginLeft: 6, color: 'white' } }))));
};
export const ButtonWithLoader = ({ onClick, className, message, disabled, isLoading, color, name }) => {
    const type = onClick ? 'button' : 'submit';
    const additionalClass = className ?? '';
    return message && message.length !== 0 ? (React.createElement("span", { className: "u-padding-top-medium u-padding-bottom-medium" }, message)) : (React.createElement(AdornedButton, { className: `u-margin-bottom-small ${additionalClass}`, color: color ?? 'primary', disabled: disabled, loading: isLoading, onClick: onClick, type: type, variant: "contained" }, name));
};
